export default "__VITE_ASSET__BL516edF__"